/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionListEntryTimExecutionPayor
 */
export interface PalSubmissionListEntryTimExecutionPayor {
    /**
     * 
     */
    name?: string;
}

/**
 * Check if a given object implements the PalSubmissionListEntryTimExecutionPayor interface.
 */
export function instanceOfPalSubmissionListEntryTimExecutionPayor(value: object): value is PalSubmissionListEntryTimExecutionPayor {
    return true;
}

export function PalSubmissionListEntryTimExecutionPayorFromJSON(json: any): PalSubmissionListEntryTimExecutionPayor {
    return PalSubmissionListEntryTimExecutionPayorFromJSONTyped(json, false);
}

export function PalSubmissionListEntryTimExecutionPayorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryTimExecutionPayor {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PalSubmissionListEntryTimExecutionPayorToJSON(json: any): PalSubmissionListEntryTimExecutionPayor {
    return PalSubmissionListEntryTimExecutionPayorToJSONTyped(json, false);
}

export function PalSubmissionListEntryTimExecutionPayorToJSONTyped(value?: PalSubmissionListEntryTimExecutionPayor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

